import React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import styles from 'custom/style.module.css';
import commonStyles from '../../../../../custom/style.module.css';
import { CloseIconBtn } from 'custom/constants';
import Warning from  '../../../../../assets/images/actionIcons/warning.svg';
import { CheckCircle } from '@mui/icons-material';

const Status = (props) => {
  return (
    <div>
      <Dialog
        open={props.statusModal}  
        onClose={props.onClose}
        aria-labelledby=''
        aria-describedby=''
        maxWidth={props.statusMessage.size}
        fullWidth={true}
      >
        <DialogTitle className={styles.fSpaceBtw} sx={{ borderBottom: '1px solid #f0f0f0' }}>
          <Typography variant='h6' component={'h6'} color={'primary'}>{props.statusMessage.title}</Typography> 
          <CloseIconBtn onClick={() => props.onClose()} />
        </DialogTitle>
        <DialogContent sx={{ padding: '0px 24px 36px 24px' }}>
          <div className={commonStyles.downloadWrapper}>
            <div className={`${styles.textCenter}`}>
              <>
                {props.type === 'success' ? 
                  <CheckCircle sx={{ fontSize: 80 }} color='secondary' />:
                  <img src={Warning} alt='warning' width={120} height={120} />}
                <Typography variant='h6' component={'h6'} color={'primary'} textAlign={'center'} mb={props.type === 'success' ? 3 : 0} mt={props.type === 'success' ? 3 : '-20px'}>
                  {props.statusMessage.mainMessage} 
                </Typography>
              </>
            </div>
            <DialogContentText fontSize={'0.9rem'} textAlign={'center'} mt={props.type === 'success' ? 3 : 1}>
              {props.statusMessage.firstMessage}<br />
              {props.statusMessage.secondMessage}
            </DialogContentText>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Status;
